import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl } from 'src/globals';
import { getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BusyService } from '../_services/busy.service';
import { HubConnection } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { activesubscriptions_returndata } from 'src/types/activesubscriptions_returndata';
import { cEmailTemplateReq } from 'src/types/emailtemplatereq';


@Component({
  selector: 'app-bookingblock',
  templateUrl: './bookingblock.component.html',
  styleUrls: ['./bookingblock.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BookingblockComponent implements OnInit {
  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  BookingDate: Date;
  PreviousBookingDate: Date;
  hubConnection: HubConnection;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;
  startdate: string = "";
  displayDate: string = "";

  emailTemplateDate: string = "";
  emailTemplateTime: string = "";

  bcItems: MenuItem[];
  home: MenuItem;
  PreviousHubs: string[] = [];
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  useCounters: boolean = false;

  EmailTemplates: any[] = [];
  selectedEmailTemplate: any;

  templateValid: boolean = true;

  PeopleAdmitted: boolean = false;

  cols: any[];

  showSubscriptionlWarning: boolean = false;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  ExampleEmail: string = "";
  EmailContainsDynamicText: boolean = false;
  DynamicContentButton: string = "";

  ShowDynamicTextEditor: boolean = false;
  dynamicTextArray: any[] = [];
  MasterCopy: string= "";

  EmailSubject: string = "";

  EmailText: string = "";
  backUpText: string = "";

  subjectValid: boolean = true;
  textValid:  boolean = true;
  textValidDT:  boolean = true;
  ShowDynamicContent: boolean = true;

  scannedBookingRef: string = null;
  selectedAction: any = null;

  screenwidth: number = window.innerWidth;
  screenheight: number = window.innerHeight;

  get isBookingDateToday(): boolean {
    if (!this.BookingDate) return false;
    const today = new Date();
    return this.BookingDate.getFullYear() === today.getFullYear()
      && this.BookingDate.getMonth() === today.getMonth()
      && this.BookingDate.getDate() === today.getDate();
  }

  get useMobileView(): boolean {
    if (this.screenwidth <= 768) return true;
    return this.screenwidth <= 1024 && this.screenheight > this.screenwidth;
  }
  @ViewChild('resourceTable') resourceTable: any;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService) {
      
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("HOME", user)){
          this.AccessAllowed = true;
        }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
    }

refreshData()
  {
    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    this.http.get(bmxurl + "RegenerateBookingMin/" + this.VenueID + "/" + dateChosen).subscribe(response => {
      this.httpResponse =  (response as any)
      if(this.httpResponse.succeeded)
      {
        this.loadgrid(false);
      }
    }, error => { 
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting date, error:' + error.messages[0]});
    });

  }

  viewcounters(bookingId){

    let dStartDate = new Date(this.startdate);
    let BookingDateYear = dStartDate.getFullYear();
    let BookingDateMonth = ('00' + (dStartDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + dStartDate.getDate()).slice(-2);
    
    let NewDate: string = BookingDateDay + BookingDateMonth + BookingDateYear;

    this.router.navigateByUrl("/counterslist/" + NewDate + "/" + bookingId);
  }

  DatifyString(date: string): Date
  {
    let returnDate = new Date();

    returnDate.setUTCFullYear(Number(date.substring(0, 4)));
    returnDate.setUTCMonth(Number(date.substring(5, 7)) - 1);
    returnDate.setUTCDate(Number(date.substring(8, 10)));
    returnDate.setUTCHours(0);
    returnDate.setUTCMinutes(0);
    returnDate.setUTCSeconds(0);

    return returnDate;
  }

  refreshList(){
    this.loadgrid(false);
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", () => {
      this.screenwidth = window.innerWidth;
      this.screenheight = window.innerHeight;
    });

    this.scannedBookingRef = localStorage.getItem("ScannedBookingRef");
    if (this.scannedBookingRef) { localStorage.removeItem("ScannedBookingRef"); }

    this.useCounters = localStorage.getItem("UseCounters") == "true" ? true : false;
    this.startdate = this.route.snapshot.paramMap.get('startdate');

    let NewDate = new Date(this.startdate);
    
    this.displayDate = ('00' + (NewDate.getDate())).slice(-2) + "/" + ('00' + (NewDate.getMonth() + 1)).slice(-2) + "/" + NewDate.getFullYear() + " " + ('00' + NewDate.getHours()).slice(-2) + ":" + ('00' + NewDate.getMinutes()).slice(-2);

    this.emailTemplateDate = ('00' + (NewDate.getDate())).slice(-2) + ('00' + (NewDate.getMonth() + 1)).slice(-2) + NewDate.getFullYear().toString().substr(-2);//NewDate.getFullYear();
    this.emailTemplateTime = ('00' + NewDate.getHours()).slice(-2) + ('00' + NewDate.getMinutes()).slice(-2);

    this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.EmailTemplates = (response as emailtemplate_returndata).data;
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
    });

    this.BookingDate = NewDate;
    this.loadgrid(false);

       this.cols = [
      { field: 'bookingIdHR', header: 'Sales ID' },
      { field: 'createddateCSV', header: 'Created Date' },
      { field: 'startTimeCSV', header: 'Start Date/Time' },
      { field: 'name', header: 'Name' },
      { field: 'email', header: 'Email' },
      { field: 'phone', header: 'Phone' },
      { field: 'packageName', header: 'Package' },
      { field: 'guests', header: 'Guests' },
      { field: 'admissions', header: 'Admissions' },
      { field: 'total', header: 'Total' },
      { field: 'outstanding', header: 'Outstanding' },
      { field: 'extraslist', header: 'Extras' },
      { field: 'allergy', header: 'Allergy' },
      { field: 'notes', header: 'Notes' },
      ];

  }

  maskMobile(MobileIn)
  {
    //only show last 4 digits
    if(MobileIn != null && MobileIn.length > 4)
    {
      let last4 = MobileIn.slice(-4);
      let masked = "**** **** " + last4;
      return masked;
    }
  }

  getNumberOfDynamicElements(InString, InWord)
  {
    let count = 0;
    let position = InString.indexOf(InWord);

    while (position !== -1) {
      count++;
      position = InString.indexOf(InWord, position + 1);
    }
    return count;
  }

  SaveText(){
    this.ExampleEmail = this.backUpText;
    this.dynamicTextArray.forEach(element => {
      this.ExampleEmail = this.ExampleEmail.replace("{{DYNAMICTEXT}}", element.text);
    });

    this.ShowDynamicContent = false;

    this.EmailText = this.ExampleEmail;
  }

  showDynamicText()
  {
    this.ShowDynamicContent = true;
  }

  CancelText()
  {
    this.dynamicTextArray.forEach((element: any) => {
      element.text = "";
    });
  }

  changeTemplate()
  {
    this.textValid = true;
    this.textValidDT = true; 

    this.dynamicTextArray = [];

    this.http.get(bmxurl + "/emailtemplateexample/" + this.VenueID + "/" + this.selectedEmailTemplate.emailtemplateid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ExampleEmail = (response as any).data; 

        this.backUpText = this.ExampleEmail;
        this.MasterCopy = this.ExampleEmail;

        this.EmailSubject = this.selectedEmailTemplate.emailsubject;

        let i = this.getNumberOfDynamicElements(this.ExampleEmail, "{{DYNAMICTEXT}}");

        if(i > 0)
        {
          if(i == 1)
          {
            this.DynamicContentButton = "You have a dynamic text area, please click here to edit it.";
          }
          else
          {
            this.DynamicContentButton = "You have " + i + " dynamic text areas, please click here to edit them.";
          }
          
          this.EmailContainsDynamicText = true;

          let indexid = 1
          for(let x = 0; x < i; x++)
          { 
            this.dynamicTextArray.push({text: "", index: indexid});
            indexid++;
            this.ShowDynamicTextEditor = true;
          }
        }
        else
        {
          this.DynamicContentButton = "";
          this.EmailContainsDynamicText = false;
        }

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates Example, error: ' + error.messages});
    });
  }

  sendEmailToAllBookings()
  {
    let canaccessemails = localStorage.getItem("BetaEmailing");
``
    if(canaccessemails != "true")
    {
      this.messageService.add({life: 7000, severity:'warn', summary:'Not Allowed', detail:"Our messaging system is in beta mode. You're invited to test it and provide feedback at support@smart-entertainment.co.uk. During the beta phase, this service is free. You can turn this on by going to settings and setting 'Event Beta Emailing' to 'Yes' in the Beta section"});
      return;
    }
    else
    {
      this.templateValid = true

      if(this.selectedEmailTemplate == null)
      {
        this.templateValid = false
      }
      else
      {
        this.templateValid = true

        if (confirm("Are you sure you want to send this email to all bookings?"))
        {
          let emailToSend: any = {};
          emailToSend.venueid = this.VenueID;
          emailToSend.date = this.emailTemplateDate;
          emailToSend.time = this.emailTemplateTime;
          emailToSend.dynamicText = this.dynamicTextArray;
          emailToSend.templateid = this.selectedEmailTemplate == null ? "" : this.selectedEmailTemplate.emailtemplateid;
          emailToSend.emailsubject = this.EmailSubject;
          
          this.http.post(bmxurl + "sendtemplate", emailToSend).subscribe(response => {
            this.CreateUpdateResponse = response
            if(this.CreateUpdateResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Email Sent', detail:'Email successfully sent to all bookings'});
              this.selectedEmailTemplate = null
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Sent', detail: 'An error occurred sending email to all bookings'});
          })
        }
      }
    
    }
  }

  getToManageWaivers(bookingId)
  {
    this.router.navigate(['/managewaivers', bookingId], { 
      queryParams: { returnDate: this.startdate } 
    });
  }
  
  returnToList(){
    this.router.navigateByUrl("/ataglance/" + this.startdate);
  }

  admitall(Id)
  {
    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + Id).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers have been marked as \'admitted\' for this booking.'});
        this.updategrid(Id, "admit");
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
    })
  }

  updategrid(Id, admitleave)
  {
    let thisBooking: any = this.ListBookings.filter(obj => obj.bookingId == Id);
    if(thisBooking != null && thisBooking.length > 0)
    {
      if(admitleave == "admit")
        thisBooking[0].checkedin = true;
      else
        thisBooking[0].checkedin = false;
    }
  }

  leaveall(Id)
  {
    this.http.get(bmxurl + "BookingCheckout/" + this.VenueID + "/" + Id).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Left', detail:'All customers have been marked as \'left\' for this booking.'});
        this.updategrid(Id, "leave");
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred leaving all customers for this booking'});
    })
  }

  PeopleAreAdmitted(inBooking)
  {
    let foundAdmitted = false
    inBooking.counteradmissions.forEach(element => {
      if(element.admitted == true)
      {
        foundAdmitted = true
      }
    });

    this.PeopleAdmitted =  foundAdmitted;
  }

  editdata(ID){
    this.router.navigateByUrl("/editbooking/" + ID);
  }

  editdatanew(ID){
    this.router.navigateByUrl("/editbooking/" + ID + "/" + this.startdate);
  }

  // toggleDisabled(){
  //   this.loadgrid(!this.isDisabled);
  // }

  // disableData(BookingID)
  // {
  //   if (confirm("Are you sure you want to disable this booking?"))
  //    {
  //       this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + BookingID).subscribe(response => {
  //         this.CreateUpdateResponse = response
  //         if(this.CreateUpdateResponse.succeeded)
  //         {
  //           this.messageService.add({severity:'success', summary:'Disabled', detail:'Booking successfully disabled'});
  //           this.disableLocal(BookingID, true);
  //         }
  //       }, error => {
  //         this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Booking'});
  //       })
  //     }
  // }

  // disableLocal(BookingID, disabled: boolean)
  // {
  //   let thisBooking: any  = this.ListBookings.filter(obj => obj.bookingId != BookingID);
  //   if(thisBooking != null && thisBooking.length > 0)
  //     {
  //       if(disabled == true)
  //         thisBooking[0].disabled = true;
  //       else
  //         thisBooking[0].disabled = false;
  //     }
  // }


  emailConf(BookingID)
  {
    this.http.get<any>(bmxurl + "confirmationemail/" + this.VenueID + "/" + BookingID).subscribe(response => {
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'Sent Booking Confirmation.'})
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not send Booking Confirmation: ' + response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send Booking Confirmation'});
    })
  }


  loadgrid(showdisabled: boolean)
  {
    let newDate = new Date(this.startdate);

    let BookingDateYear = newDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (newDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + newDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    let timeChosen = ('00' + newDate.getHours()).slice(-2) + ('00' + newDate.getMinutes()).slice(-2);

    //this.busyService.busy();
    this.http.get(bmxurl + "BookingListTimeDateMin/" + this.VenueID + "/" + dateChosen + "/" + timeChosen + "/" + showdisabled).subscribe(response => {
      try{
        this.CreateUpdateResponse = (response as any);

        //Get VenueDate
        this.ListBookingsGlobal = this.CreateUpdateResponse.data;

        var thisYear: any = newDate.getFullYear();
        var thisMonth: any = ('00' + (newDate.getMonth() + 1)).slice(-2);
        var thisDay: any = ('00' + newDate.getDate()).slice(-2);
        var fullDate: any = thisYear + thisMonth + thisDay;

        let venueDate: string =  this.VenueID + "_" + fullDate;

        if(this.inProgress)
        {
          this.ListBookings = this.ListBookingsGlobal.filter(obj => obj.venuedate == venueDate && obj.inProgress == true);

          this.ListBookings.forEach(element => {
          element.startTimeCSV = this.formatDateForExcel(element.startTime);
          element.createddateCSV = this.formatDateForExcel(element.createddate);

          let extraslist: string = "";

          if(element.extras != null)
            {
              if(element.extras.length > 0)
              { 
                element.extras.forEach(extra => {
                  if(extra.qty > 0)
                    extraslist += extra.name + " (" + extra.qty + "), ";
                });
              }

              if(extraslist.length > 2)
                element.extraslist = extraslist.substring(0, extraslist.length - 2);
            }
          });
        }
        else
        {
          this.ListBookings = this.ListBookingsGlobal.filter(obj => obj.venuedate == venueDate && obj.inProgress == false);

          this.ListBookings.forEach(element => {
          element.startTimeCSV = this.formatDateForExcel(element.startTime);
          element.createddateCSV = this.formatDateForExcel(element.createddate);

          let extraslist: string = "";
          if(element.extras != null)
            {
              if(element.extras.length > 0)
              { 
                element.extras.forEach(extra => {
                  if(extra.qty > 0)
                    extraslist += extra.name + " (" + extra.qty + "), ";
                });
              }

              if(extraslist.length > 2)
                element.extraslist = extraslist.substring(0, extraslist.length - 2);
            }
          });
        }

        this.bookingsInProgress = this.ListBookingsGlobal.filter(obj => obj.inProgress == true).length;
        this.totalBookingsToday = this.ListBookingsGlobal.filter(obj => obj.inProgress == false).length;

        this.ListBookings.forEach(element => {
          if(element.admitted != null)
            element.admitted = this.PeopleAreAdmitted(element);
        });

        if (this.scannedBookingRef && this.resourceTable) {
          setTimeout(() => {
            this.resourceTable.filterGlobal(this.scannedBookingRef, 'contains');
          }, 0);
        }
      }
      catch (error){
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally{
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  // disableMulti()
  // {
  //   this.selectedItems.forEach(element => {

  //   this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + element.bookingId).subscribe(response => {
  //     this.CreateUpdateResponse = response
  //     if(this.CreateUpdateResponse.succeeded)
  //     {
  //       this.disableLocal(element.bookingId, true);
  //     }
  //   }, error => {

  //   })
  //   });

  // }

  doneDate(){

    this.inProgress = false;

    this.loadgrid(false)

    this.PreviousHubs.forEach(element => {
      this.hubConnection.off(element);
    });

    this.PreviousHubs = [];

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

    this.PreviousHubs.push(BookingEventDate);

    this.hubConnection.on(BookingEventDate, data => {
      this.loadgrid(false);
    });

  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  dateChange(num)
  {
    this.BookingDate = this.addDays(new Date(this.BookingDate), num);
    this.doneDate();
  }

  subscribe()
  {
    this.router.navigateByUrl("/subscriptions");
  }

  customSort(event: any) {
    event.data.sort((a: any, b: any) => {
      let result = 0;

      if (event.field === 'resourcestring') {
        const res1 = a.resourcestring ?? '';
        const res2 = b.resourcestring ?? '';
        result = res1.localeCompare(res2);
        if (result === 0) {
          const d1 = new Date(a.startTime).getTime();
          const d2 = new Date(b.startTime).getTime();
          result = d1 < d2 ? -1 : d1 > d2 ? 1 : 0;
        }
      } else {
        const val1 = a[event.field];
        const val2 = b[event.field];
        if (val1 == null && val2 != null) result = -1;
        else if (val1 != null && val2 == null) result = 1;
        else if (val1 == null && val2 == null) result = 0;
        else if (typeof val1 === 'string' && typeof val2 === 'string') result = val1.localeCompare(val2);
        else result = val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
      }

      return event.order * result;
    });
  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  }

